










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Tab extends Vue {
  @Prop(String) label!: string;
  @Prop({ default: false }) isActive?: boolean;
}
